// src/config/queryClient.ts
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // ============================================
      // CACHING STRATEGY
      // ============================================
      staleTime: 2 * 60 * 1000, // Data stays fresh for 2 minutes
      gcTime: 10 * 60 * 1000, // Cache kept for 10 minutes (formerly cacheTime)
      
      // ============================================
      // RETRY STRATEGY
      // ============================================
      retry: (failureCount, error: any) => {
        // Don't retry on 404s or auth errors
        if (error?.code === 'permission-denied' || error?.code === 'not-found') {
          return false;
        }
        // Retry up to 3 times for network errors
        return failureCount < 3;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      
      // ============================================
      // REFETCH STRATEGY
      // ============================================
      refetchOnWindowFocus: true, // Refetch when user returns to tab
      refetchOnReconnect: true, // Refetch when connection restored
      refetchOnMount: true, // Refetch when component mounts
      
      // ============================================
      // ERROR HANDLING
      // ============================================
      throwOnError: false, // Don't throw errors globally
      
      // ============================================
      // PERFORMANCE
      // ============================================
      structuralSharing: true, // Prevent unnecessary re-renders
    },
    mutations: {
      retry: 1, // Retry mutations once on failure
      onError: (error) => {
        console.error('Mutation error:', error);
      },
    },
  },
});